import React, { useEffect, useRef, useContext, useState, forwardRef } from "react";
import "./widgetcss/styles.css";
import "../Judumas.css"
import DatePicker, {registerLocale} from "react-datepicker";
import { operatorAvailableDates } from "../Services/serviceLayers";
import esriConfig from "@arcgis/core/config";
import lt from "date-fns/locale/lt"
import { MapContext } from "../MapContext";
import uniqueValues from "@arcgis/core/smartMapping/statistics/uniqueValues";
import { toISOLocal } from "../helpers/helper";
import { transoprationAvailableDatesParam } from "../helpers/helper";

registerLocale("lt", lt); 
// Kalendoriaus elementas, paduodamas tokenas, monthWeekDay - ar rodyti mygtukus menesiui, savaitei ir dienai, dispatcher - ar turi buti kalendorius palyginimui antrai datai, headerText - antraste
// colorScheme - css spalvu parinktis, inlineBool - ar kalendorius turi buti kaip pop-upas ar issipleciantis elementas, existingStartDate ir existingEndDate - esamos datos, dataSource - duomenu saltinis, canSelectRange - ar galima pasirinkti datas kaip rezi
export default function Calendar ({token, monthWeekDay, dispatcher, headerText, colorScheme, inlineBool, existingStartDate = null , existingEndDate = null , dataSource=null, canSelectRange = true}) {
    const mapContext = useContext(MapContext);

    // datos kurios kalendoriuje yra rodomos kaip pasirinktinos
    const [availableDates, setAvailableDates] = useState([]);
    // suskleisti/iskleisti kalendoriu
    const [datePickerState, setDatePickerState] = useState(0);
    // pradinio renderinimo flagas, kad neaktyvuoti ko nereikia kol nereikia
    const [initialRender, setInitialRender] = useState(0);
    // pasirinktu datu rezis
    const [dateRange, setDateRange] = useState([existingStartDate, existingEndDate]);
    // datos kurios rodomos kalendoriuje jei jos yra
    const [startDate, endDate] = dateRange;

    // menesio, savaites, dienos pasirinkimo mygtukai
    const setCalndarBtn = (option) => {
        let availCpy = [...availableDates]
        //console.log(availCpy)
        availCpy = availCpy.filter(date => !isNaN(new Date(date).getTime()));
        availCpy.sort((a, b) => new Date(a) - new Date(b));
        //console.log(availCpy)
        let firstDate = new Date(availCpy[availCpy.length-1])
        //console.log(firstDate)
        switch(option) {
        case 'Day':
          firstDate.setDate(firstDate.getDate());
          break;
        case 'Week':
          firstDate.setDate(firstDate.getDate() - 7);
          break;
        case 'Month':
          firstDate.setMonth(firstDate.getMonth() - 1);
          break;
        default:
        }
        setDateRange([firstDate , availCpy[availCpy.length-1]])
      }

      // rodoma parinkta data arba tekstas
      const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <button className={"DatePickerInput " + colorScheme} onClick={onClick} ref={ref}>
          {value != "" ? value  : "Kalendorius"}
        </button>
      ));
    

      // laukia kol elementas atsiras
      function waitForElm(selector) {
        return new Promise((resolve) => {
          if (document.querySelector(selector)) {
            return resolve(document.querySelectorAll(selector));
          }
    
          const observer = new MutationObserver((mutations) => {
            if (document.querySelector(selector)) {
              resolve(document.querySelectorAll(selector));
              observer.disconnect();
            }
          });
    
          observer.observe(document.body, {
            childList: true,
            subtree: true,
          });
        });
      }

      // pasirenktos datos performatuojamos i query uzklausos formata
      useEffect(() => {
        if (dateRange[0] !== null && dateRange[1] !== null){
            mapContext.dispatch({
                watherCheckIfOneDay: dateRange,
            });
            let day = new Date(dateRange[0]);
            day.setDate(day.getDate() - 1);
            let dateRangeLocal =
              "datetime >= timestamp'" +
              day.toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" }) +
              " 23:59:59' and datetime < timestamp'" +
              dateRange[1].toLocaleDateString("en-US", { month: "2-digit", day: "2-digit", year: "numeric" }) +
              " 23:59:59'";
            if  (dispatcher === 0) {
              mapContext.dispatch({
                dateRange: dateRangeLocal,
              });
            } else {
              mapContext.dispatch({
                compareDate: dateRangeLocal,
              });
            } 
        }
      }, [dateRange]);

      useEffect(() => {
        //console.log("intiail render " + initialRender)
      },[initialRender])

      // sudedavo datas i mapContext, kad galetume jas naudoti pasiekiamume, gali buti legacy reikalavimas, nes pasiekiamume kalendorius yra nurestetinamas
      useEffect(() => {
        let resetDates = [startDate, endDate]
        //console.log(resetDates)
        mapContext.dispatch({
          calendarResetDates: [...resetDates]
        });
        //console.log(mapContext.state.calendarResetDates)
        if (dispatcher === 0 && mapContext.state.dateRange === null){
          setDateRange([null,null])
          //console.log("2")

        } else if (dispatcher !== 0 && mapContext.state.compareDate === null) {
          setDateRange([null,null])
          //console.log("3")

        }
        //console.log(dateRange)
        //console.log(startDate)
        //console.log(endDate)
      },[mapContext.state.dateRange, mapContext.state.compareDate])

      // iskviecia funkcija gauti available datom
      useEffect(() => {
        if (initialRender === 0) {
          if (dataSource !== null) {
            setAvailableDates(dataSource)
            return;
          }
          if (mapContext.state.dateWithData != null) {
            setAvailableDates(mapContext.state.dateWithData);
            return;
          }  
    
          esriConfig.request.interceptors.push({
            // set the `urls` property to the URL of the FeatureLayer so that this
            // interceptor only applies to requests made to the FeatureLayer URL
            urls: [mapContext.state.dataurl],
    
            error: function (error) {
            },
    
            before: async function (params) {
              params.requestOptions.query.token = token;
              params.requestOptions.query = params.requestOptions.query || {};
            },
          });

          availableDatesQuery()

          setInitialRender(1);
        }
      });

      // pakeitus transportavimo tipa, iskviecia funkcija gauti available datom
      useEffect(() => {
        if (initialRender === 0) {
          return
        }
        availableDatesQuery()
        //console.log("Available date changed")
      },[mapContext.state.transportation])

      // paquerinamos available datos kurias rodo kalendoriuje
    function availableDatesQuery() {
      let dateParam
      if (mapContext.state.compareTask !== 3) {
        dateParam = transoprationAvailableDatesParam(mapContext)
      } else {
        dateParam = "date_str"
      }
     

      uniqueValues({
        layer: operatorAvailableDates,
        field: dateParam,
      }).then(function (response) {
        // prints each unique value and the count of features containing that value
        let infos = response.uniqueValueInfos;
        let availableDatesLocal = [];
        let parsedDates = [];
        const minDate = new Date(2024, 0, 1); // 01/01/2024

        infos.forEach(function (info) {


          if (!availableDatesLocal.includes(info.value) && info.value != null) {

            let splitDate = info.value.split('/')
            let addDate = new Date(splitDate[0], splitDate[1] - 1, splitDate[2]);

            // Filter dates for Bike, Bus, or Pedestrian transportation
            const isRestrictedTransport = ["Bike", "Bus", "Pedestrian"].includes(mapContext.state.transportation);
            if (isRestrictedTransport && addDate < minDate) {
              return; // Skip dates before 01/01/2024 for these transport types
            }

            parsedDates.push(addDate);
            availableDatesLocal.push(info.value);

          }
        });

        setAvailableDates(parsedDates);
        mapContext.dispatch({
          dateWithData: parsedDates,
        });
      });
    }

    return (

        <>
        <div className="">
            {headerText}
            
            {}
        </div>
        
        { availableDates.length === 0 ? <div class="loader"></div> :
                monthWeekDay === true ? 
                <>
                <button className=' ClearBtn SidebarBtn'onClick={() => {setCalndarBtn("Month")}}>Mėnuo</button>
                <button className=' ClearBtn SidebarBtn'onClick={() => {setCalndarBtn("Week")}}>Savaitė</button>
                <button className=' ClearBtn SidebarBtn' onClick={() => {setCalndarBtn("Day")}}>Diena</button> 
                
                </>
                :
                <></>}
        {}
        {inlineBool === false ?   <><DatePicker
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            customInput={<ExampleCustomInput/>}
            calendarClassName={"DatePickerWrapper " + colorScheme}
            selectsDisabledDaysInRange={true}
            inline = {inlineBool}
            includeDates={availableDates}
            placeholderText="YYYY-MM-DD"
            locale={"lt"}
            disabledKeyboardNavigation
            onChange={(update) => {
            setDateRange(update);
            waitForElm(".SidebarBtn").then((button) => {
                    button.forEach((nav) => nav.classList.remove("Active"));
                    });
                  }}
            /></> :
         (datePickerState === 1) ? <><DatePicker
            selectsRange={canSelectRange}
            startDate={startDate}
            endDate={endDate}
            customInput={<ExampleCustomInput/>}
            calendarClassName={"DatePickerWrapper " + colorScheme}
            selectsDisabledDaysInRange={true}
            inline = {inlineBool}
            includeDates={availableDates}
            placeholderText="YYYY-MM-DD"
            locale={"lt"}
            disabledKeyboardNavigation
            onChange={(update) => {
              if (canSelectRange === false) {
                setDateRange([update, update]);
              } else {
                setDateRange(update);
              }
            
            waitForElm(".SidebarBtn").then((button) => {
                    button.forEach((nav) => nav.classList.remove("Active"));
            });
            }}
        />
        <button className={' ClearBtn DatePickerClose ' + colorScheme} onClick={() => {setDatePickerState(0)}}>^</button>
        </> : <button className={' ClearBtn MarginBtn DatePickerOpen ' + colorScheme} onClick={() => {setDatePickerState(1)}}>{  (dateRange[0] == null || dateRange[1] == null) ? "Kalendorius" : toISOLocal(startDate).split('T')[0].replaceAll('-', '/')  + " - "+toISOLocal(endDate).split('T')[0].replaceAll('-', '/')}</button> }
        </>
    )
}
